import Cards from "../Cards/Cards";
import RatingPsychologists from "../RatingPsycologists/RatingPsycologists.jsx"

export default function Psychologists() {
  return (
    <>
        <hr/>
        <div className="">
        <Cards/>
        </div>
       
        <hr />
    </>
  )
}
